export default "__VITE_ASSET__96f19c27__"